<div class="title-2">{{ 'classification-check-preview.title' | translate }}</div>

<div class="container">
  <div class="content-container" *ngIf="!expanded"></div>
  <div class="content-container" *ngIf="expanded">
    <div class="checks-container"
         *ngIf="availableChecks.medicalFood || availableChecks.complementaryMedicine || availableChecks.behavioralTreatment;else noChecks">
      <div class="check" *ngIf="availableChecks.medicalFood">
        <span class="title">{{ 'classification-check-preview.labels.medical-food-prescription' | translate }}</span>
        <span class="value"
           *ngIf="checksPerformed.medicalFoodPrescription !== undefined">{{ checksPerformed.medicalFoodPrescription | booleanTranslate }}</span>
        <span class="value"
           *ngIf="checksPerformed.medicalFoodPrescription === undefined">{{ 'classification-check-preview.no-value' | translate }}</span>
      </div>

      <div class="check" *ngIf="availableChecks.complementaryMedicine">
        <span class="title">{{ 'classification-check-preview.labels.complementary-medicine-prescription' | translate }}</span>
        <span class="value"
           *ngIf="checksPerformed.complementaryMedicinePrescription !== undefined">{{ checksPerformed.complementaryMedicinePrescription | booleanTranslate }}</span>
        <span class="value"
           *ngIf="checksPerformed.complementaryMedicinePrescription === undefined">{{ 'classification-check-preview.no-value' | translate }}</span>
      </div>

      <div class="check" *ngIf="availableChecks.complementaryMedicine">
        <span class="title">{{ 'classification-check-preview.labels.complementary-medicine-therapist' | translate }}</span>
        <span class="value"
           *ngIf="checksPerformed.complementaryMedicineTherapist !== undefined">{{ checksPerformed.complementaryMedicineTherapist | booleanTranslate }}</span>
        <span class="value"
           *ngIf="checksPerformed.complementaryMedicineTherapist === undefined">{{ 'classification-check-preview.no-value' | translate }}</span>
      </div>

      <div class="check" *ngIf="availableChecks.behavioralTreatment">
        <span class="title">{{ 'classification-check-preview.labels.behavioural-treatment-therapist' | translate }}</span>
        <span class="value"
           *ngIf="checksPerformed.behavioralTreatmentTherapist !== undefined">{{ checksPerformed.behavioralTreatmentTherapist | booleanTranslate }}</span>
        <span class="value"
           *ngIf="checksPerformed.behavioralTreatmentTherapist === undefined">{{ 'classification-check-preview.no-value' | translate }}</span>
      </div>
    </div>

    <ng-template #noChecks>
      <h3>{{ 'classification-check-preview.no-checks-available' | translate }}</h3>
    </ng-template>
  </div>
  <div class="actions">
    <mat-icon (click)="expanded = !expanded" class="expand-button" [class.expand]="!expanded">expand_less</mat-icon>
  </div>
</div>
